export default __webpack_public_path__ + "static/media/developer-logotype-d.ea7bcc31.svg";